import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../../components/buttons/PrimaryButton";
import { PdfCard, PdfType } from "../../../pages/new-platform/components/PdfCard";
import { Exam } from "../../../utils/api-objects/Exam";
import { getAllExamsByType } from "../../../utils/apis/emr-service";
import { BASE_URL, requestOptionsGET } from "../../../utils/Constants";
import { BucketFolder } from "../../../utils/enums/BucketFolder";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { useFilesStore } from "../../../utils/stores/useFilesStore";
import LoadingSpinner from "../../shared/components/Loaders";

// TODO [TM]: add here also the klippa document
const UploadedFromYou = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const userId = auth.userId
    const idToken = auth.idToken
    const { updateFilesData } = useFilesStore()
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(false)

    const onUploadClick = () => {
        navigate("/reports/upload?type=classic")
        // (document.querySelector(`.file-input-box-${PdfType.Uploads}`) as HTMLElement).click()
    };

    const [uploadedFile, setUploadedFile] = useState<File>()

    const [exams, setExams] = useState<Exam[]>()

    const onFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        const file = files[0];
        const allowedTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];
        const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

        if (!allowedTypes.includes(file.type)) {
            console.log("Invalid file type");
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            console.log("File too large");
            return;
        }

        setUploadedFile(file);

        // Auto-publish after setting the file
        setTimeout(() => onPublishClick(file), 100);
    };

    const onPublishClick = async (file?: File) => {
        const selectedFile = file || uploadedFile;
        if (!idToken || !selectedFile) return;

        setIsLoading(true);
        const filename = selectedFile.name;
        const fileType = selectedFile.type;

        try {
            console.log("Uploading file type:", fileType);
            const response = await fetch(
                `${BASE_URL}/api/health-plans/user/${userId}/upload-url?filename=${encodeURIComponent(filename)}&folder=from_user&content_type=${encodeURIComponent(fileType)}`,
                requestOptionsGET(idToken)
            );

            if (!response.ok) {
                console.error("Error fetching upload URL");
                return;
            }

            const urlResponse = await response.json();

            const formData = new FormData();
            Object.entries(urlResponse.fields).forEach(([k, v]) => {
                formData.append(k, v as unknown as string);
            });
            formData.append("file", selectedFile);

            const s3response = await axios.post(urlResponse.url, formData);

            if (s3response.status === 204) {
                console.log("File uploaded successfully");
                setTriggerRefresh(true);
            } else {
                console.log("File not uploaded");
            }
        } catch (error) {
            console.error("Upload failed", error);
        } finally {
            setIsLoading(false);
            setUploadedFile(undefined);
        }
    };

    const [triggerRefresh, setTriggerRefresh] = useState(false)

    useEffect(() => {
        if (!userId || !idToken) return;

        const fetchExams = async () => {
            setIsLoading(true);
            try {
                const results: Exam[][] = await Promise.all([
                    new Promise<Exam[]>((resolve, reject) => {
                        getAllExamsByType(
                            userId,
                            idToken,
                            BucketFolder.UploadedFromUser,
                            resolve,
                            reject
                        );
                    }),
                    // new Promise<Exam[]>((resolve, reject) => {
                    //     getAllExamsByType(
                    //         userId,
                    //         idToken,
                    //         BucketFolder.Documents,
                    //         resolve,
                    //         reject
                    //     );
                    // }),
                ]);

                const merged = [...results[0]];

                // const merged = [...results[0], ...results[1]];
                setExams(merged);
                updateFilesData({ userFiles: merged });

            } catch (error) {
                console.log("Error fetching exams:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchExams();
    }, [triggerRefresh, userId, idToken]);

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            <div className="mt-[10px] space-y-[10px]">
                {/* <BackButton
                    text="Torna a Test e referti"
                    onClick={() => navigate("/diagnostica/tests-and-reports")}
                /> */}
                <div className="md:flex md:justify-between md:items-center space-y-[10px] md:space-y-0">
                    {/* <div className="flex flex-col md:flex-row md:justify-between">
                        <div className="font-bold text-[25px] leading-[33px]">
                            Caricati da te
                        </div>
                    </div> */}
                    <div className="space-y-[20px]">
                        <div className="w-full h-[50px]  md:w-[362px]">
                            <PrimaryButton
                                text="Carica"
                                pointer={true}
                                disabled={false}
                                onClick={onUploadClick}
                            />
                        </div>
                    </div>
                </div>
                <input
                    type="file"
                    accept="application/pdf,image/jpg,image/jpeg,image/png"
                    className={`file-input-box-${PdfType.Uploads}`}
                    onChange={onFileInputChange}
                    hidden
                />
            </div>
            <div className="font-normal text-[16px] leading-[26px]">
                In questa cartella puoi accedere a tutti i documenti che hai condiviso con la tua Medical Equipe.
            </div>
            <div className="flex flex-wrap gap-4">
                {

                    exams && exams.length > 0 ? exams.map((exam, index) => (
                        <PdfCard key={index} exam={exam} pdfType={PdfType.Uploads} />
                    )) : <div>Al momento non ci sono documenti presenti.</div>
                }
            </div>
            <div className="pb-[20px]"></div>
            {isLoading && <div className="w-full h-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center items-center"><LoadingSpinner /></div>}
        </div>
    )
}

export default UploadedFromYou
